import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import uniqid from 'uniqid';
import ReactTooltip from 'react-tooltip';
import FontAwesome from 'react-fontawesome';
import { ConstrainedToolTipContent, _ToolTipWrapper } from "./style";
import { ERROR_OUTLINE } from "../../../../util/cdnAssets";
var ConstrainedToolTip = function ConstrainedToolTip(props) {
  // generate a unique ID on first render
  var id = useMemo(uniqid, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_ToolTipWrapper, null, /*#__PURE__*/React.createElement("a", {
    "data-tip": true,
    "data-for": id
  }, props.customIcon ? /*#__PURE__*/React.createElement("img", {
    src: ERROR_OUTLINE,
    alt: "Error outline"
  }) : /*#__PURE__*/React.createElement(FontAwesome, {
    name: props.name
  }))), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: id
  }, /*#__PURE__*/React.createElement(ConstrainedToolTipContent, null, props.text)));
};
export default ConstrainedToolTip;